import { render, staticRenderFns } from "./render-case-action.vue?vue&type=template&id=8870987a&"
import script from "./render-case-action.vue?vue&type=script&lang=js&"
export * from "./render-case-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports